<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img src="@/assets/shield.png" height="40" width="40" contain />
    </v-list-item-avatar>
    <v-list-item-content class="pl-2">
      <v-img :src="logoSrc" height="40" width="340" contain />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
// Utilities
import { get } from 'vuex-pathify'

export default {
  name: 'DefaultDrawerHeader',

  computed: {
    version: get('app/version'),
    // < img : src="" alt="Monpatrol logo" style="max-width: 220px; max-height: 80px;" />
    logoSrc() {
      return this.$vuetify?.theme?.dark
        ? '/img/monpatrol_dark.png'
        : '/img/monpatrol.png';
    },
  },
}
</script>
